import { Icon } from '@orgazone/ui-web';
import { t } from '../i18n';

/**
 * L'ÉTAT « ÉCRAN PAS ENCORE CONSTRUIT » — ce que rend une destination du menu qui n'a ni écran ni routes.
 *
 * ⚠️ POURQUOI UN COMPOSANT DÉDIÉ PLUTÔT QUE DES MAQUETTES PEUPLÉES. La tentation, avec un dessin aussi
 * abouti, est de porter les écrans avec les données de démonstration de la maquette : on obtient un
 * back-office qui a l'air de fonctionner. C'est exactement l'interdit du §23.0 — une donnée inventée
 * rendue comme réelle. Sur un logiciel de caisse, un stock ou une marge plausibles mais faux se
 * repèrent trop tard.
 *
 * ⚠️ IL NE DÉCRIT QUE CE QUI MANQUE À CETTE PAGE, jamais l'état du back-office en général : une phrase sur
 *    « ce que le serveur expose » se périme dès qu'une route est ajoutée ailleurs, et l'écran ment alors à
 *    qui le lit. Il se retire écran par écran, remplacé par du réel.
 */
export function Placeholder({ title, path }: { title: string; path: string }) {
  return (
    <>
      <header style={{ marginBottom: 18 }}>
        <h1 style={{ fontSize: 'var(--t-h1)', fontWeight: 700, letterSpacing: '-.025em', margin: 0, color: 'var(--ink-900)' }}>
          {title}
        </h1>
      </header>
      <NotBuiltYet path={path} />
    </>
  );
}

/** Le bloc « pas encore construit » d'une page du menu qui attend sa tranche : ce qui manque, et l'adresse visée. */
function NotBuiltYet({ path }: { path: string }) {
  return (
    <div
      style={{
        border: '1px dashed var(--ink-300)', borderRadius: 'var(--r-md)', padding: '28px 26px',
        maxWidth: 720, display: 'flex', gap: 16, alignItems: 'flex-start', background: 'var(--paper)',
      }}
    >
      <span style={{ color: 'var(--ink-400)', flexShrink: 0, marginTop: 2 }}><Icon name="layers" size={22} /></span>
      <div style={{ minWidth: 0 }}>
        <p style={{ margin: '0 0 10px', fontSize: 'var(--t-h4)', fontWeight: 600, color: 'var(--ink-900)' }}>
          {t('Cet écran n’est pas encore construit.')}
        </p>
        <p style={{ margin: '0 0 12px', fontSize: 'var(--t-body)', color: 'var(--ink-500)', lineHeight: 1.6 }}>
          {t('Le menu y mène, mais rien n’y est encore affiché : ni l’écran ni les données qu’il lirait n’existent. Aucun chiffre n’est montré plutôt qu’un chiffre inventé.')}
        </p>
        <p style={{ margin: 0, fontSize: 'var(--t-note)', color: 'var(--ink-400)', lineHeight: 1.6 }}>
          <code style={{ fontFamily: 'var(--font-mono)' }}>{path}</code>
        </p>
      </div>
    </div>
  );
}
